import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {
  initTelemetry,
  TelemetryErrorBoundary,
  ReportProblem,
  setupConsoleTelemetry,
} from '@cca/ui';
import { App } from './App';
// Shared design system (tokens + canonical component classes) before the app
// stylesheet; vetting keeps its own base/body.
import '@cca/ui/tokens';
import '@cca/ui/components';
import './styles/global.css';

// Production telemetry (Phase 4): window errors, unhandled rejections, render +
// API failures. Vetting is served by the parishes worker on vetting.*/api.
const apiBase = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';
initTelemetry({ portal: 'vetting', endpoint: `${apiBase}/api/telemetry` });

// Fold console.error / console.warn into the SAME redacted telemetry channel,
// source-minimised (cca-a7q, audit M3). Runs AFTER initTelemetry so the reporter
// is configured. The old raw unredacted console→/api/logs/console forwarder is
// removed.
setupConsoleTelemetry();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

createRoot(root).render(
  <StrictMode>
    <TelemetryErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ReportProblem />
    </TelemetryErrorBoundary>
  </StrictMode>,
);
